import Axios from "./index";
const likeables = {
  Post: "posts",
  Playlist: "playlists",
  Podcast: "playlists",
  Album: "albums",
  Image: "media",
  Video: "media",
  SoundTrack: "media",
};
export const like = (type, id) => {
  return Axios.post(`/user/${likeables[type]}/${id}/likes`);
};
export const unlike = (type, id) => {
  return Axios.delete(`/user/${likeables[type]}/${id}/likes/unlike`);
};
